/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m14.1069 19.7539v1.886l-3.205.984c-.666.206-1.212.984-1.212 1.73v.677h6.941-1.262 6.942v-.677c0-.746-.546-1.524-1.214-1.73l-3.203-.984v-1.886l-.004-.004c1.134-.767 1.896-2.202 1.896-3.847 0-2.45-1.696-4.438-3.786-4.438-2.091 0-3.786 1.988-3.786 4.438 0 1.642.76 3.076 1.891 3.844zm16.893 9.246h-30c-.552 0-1-.447-1-1v-23c0-.552.448-1 1-1h8.334c.262 0 .515.104.702.288l3.041 2.998h17.923c.553 0 1 .447 1 1v19.714c0 .553-.447 1-1 1zm-29-2h28v-17.714h-17.333c-.263 0-.516-.104-.703-.288l-3.041-2.998h-6.923z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;